import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup} from '@angular/forms';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ProvinceService} from '../../../shared/service/province.service';
import {ProvinceDTO} from '../../../shared/dto/province.model';
import swal from "sweetalert2";
import {ActionMode} from '../../../shared/enums/action-mode.enum';
import {ProvincePopupComponent} from './province-popup/province-popup.component';
import {TokenStorageService} from '../../../shared/service/token-storage.service';
import {Router} from '@angular/router';

@Component({
  selector: 'app-province',
  templateUrl: './province.component.html',
  styleUrls: ['./province.component.scss']
})
export class ProvinceComponent implements OnInit {
  public provinceForm: FormGroup;
  public provinceModel: ProvinceDTO[] = [];
  public provinceConfigItems: ProvinceDTO[] =[];
  public href: string = "";

  constructor(public modalService: NgbModal,
              public provinceService: ProvinceService,
              public tokenStorageService: TokenStorageService,
              private router : Router) { }

  ngOnInit() {
    this.provinceForm = new FormGroup({
      code: new FormControl(null),
      description: new FormControl(null),
      states: new FormControl(null),
    });
    this.href = this.router.url;
    this.loadProvinces();
    this.onLoadGetData();
  }

  loadProvinces() {
    this.provinceService.getAllProvinces().subscribe(
      (data: ProvinceDTO[]) => {
        this.provinceModel = data;
        this.provinceConfigItems = data;
      }
    );
  }

  onLoadGetData(): void {
    const provinceDTO = new ProvinceDTO(
      null,
      null,
      null,
      null,
      null
    )
    this.loadSearchResultList(provinceDTO);
  }

  loadSearchResultList(provinceDTO: ProvinceDTO): void {
    this.provinceService.searchProvince(provinceDTO).subscribe(
      (data: ProvinceDTO[]) => {
        this.provinceConfigItems = data;
      },
      (error) => {
        swal.fire('Sorry!', 'Something went wrong...!', 'error');
      },
      () => {
        if (this.provinceConfigItems == null || this.provinceConfigItems.length === 0) {
          swal.fire('Sorry', 'No result found.', 'error');
          this.loadProvinces();
        } else {
          this.provinceService.clearProvinceSearchDetails();
          this.provinceService.setProvinceSearchDetails(
            this.provinceConfigItems
          );
        }
      }
    );
  }

  onSubmitSearch(): void {
    let isValid: boolean = false;
    let msg: string = 'Please fill the form..!';

    if (this.provinceForm.value.code != null) {
      isValid = true;
    }
    if (this.provinceForm.value.description != null) {
      isValid = true;
    }
    if (this.provinceForm.value.states != null) {
      isValid = true;
    }
    if (isValid && this.provinceForm.valid) {
      const provinceDTO = new ProvinceDTO(
        this.provinceForm.value.code,
        this.provinceForm.value.description,
        this.provinceForm.value.states,
        this.tokenStorageService.getUserObjectToken().username,
        this.href
      );
      this.loadSearchResultList(provinceDTO);
    }
  }

  validateAllFormFields(formGroup: FormGroup) {

    Object.keys(formGroup.controls).forEach(field => {

      const control = formGroup.get(field);
      if (control instanceof FormControl) {

        control.markAsTouched({onlySelf: true});
      } else if (control instanceof FormGroup) {

        this.validateAllFormFields(control);
      }
    });
  }

  onClickReset(){
    this.provinceForm.reset({
      code: null,
      description: null,
      states: null,
    });
    this.onLoadGetData();
  }

  onClickNew(){
    const modalRef = this.modalService.open(ProvincePopupComponent, {
      windowClass: 'xlModal'
    });
    // modalRef.componentInstance.name = 'Add New Employee';
    modalRef.componentInstance.selectedMode = ActionMode.ADD;
    modalRef.componentInstance.provinceMgtCopy_ = this.provinceConfigItems;
    modalRef.result.then((data: string) => {
      if (data == 'Saved') {
        this.onLoadGetData();
        this.loadProvinces();
      }
    }, () => {

    });
  }

}
